export function setParentHeight(height: number): void {
  tellParent("set_iframe_height", `${height}px`);
}

export function camelToSnakeCase(text: string) {
  return text
    .replace(/(.)([A-Z][a-z]+)/, "$1_$2")
    .replace(/([a-z0-9])([A-Z])/, "$1_$2")
    .toLowerCase();
}

export function dehtml(string?: string, removeAsterisks = false) {
  let newString = string || "";
  newString = newString?.replace(/(<([^>]+)>)/gi, " ");
  if (removeAsterisks) newString = newString.replace(/\*\s/, "");
  return newString;
}

export function hudsonDateFormatToJavascriptFormat(hudsonFormat: string) {
  return hudsonFormat
    .replace(/HHmm/i, "h:mm")
    .replace(/HH:mm/i, "h:mm")
    .replace(/hh/i, "hh")
    .replace(/(AM)|(PM)/i, "b")
    .replace(/A|P/i, "b")
    .replace(/dddd/i, "eeee")
    .replace(/ddd/i, "eee")
    .replace(/dd/i, "d")
    .replace(/d/i, "d")
    .replace(/mmmm/i, "MMMM")
    .replace(/mmm/i, "MMM")
    .replace(/mm/i, "M")
    .replace(/nn/i, "mm")
    .replace(/ss/i, "ss")
    .replace(/yyyy/i, "yyyy")
    .replace(/ww/i, "ww");
}

const inParentFrame = () => global?.window?.self != global?.window?.parent;

export function isMobile(breakpointPx = 1079): boolean {
  return global?.window?.matchMedia(`screen and (max-width: ${breakpointPx}px)`)
    .matches;
}

export function parentRedirect(url: string): void {
  if (inParentFrame()) {
    tellParent("page_redirect", url.replace(/=/g, "%3D"));
  } else {
    window.location.href = url;
  }
}

export const parentScrollToTheTop = (): void => {
  tellParent("scroll_to_top_of_frame", 0);
};

export function scrollToElement(element: HTMLElement): void {
  element?.scrollIntoView({
    behavior: "smooth",
    block: "end",
    inline: "nearest",
  });
}

function tellParent(key: string, value: string | number): void {
  if (!inParentFrame()) return;
  window.parent.window.postMessage(`${key}=${value}`, "*");
}
